import React, { useEffect, useContext } from 'react';

import { useMapStateStore, useConfigStore } from '../../stores';
import SiteSeeContext from './SiteSeeContext';

const SiteSeeAmenitiesGuide = () => {
  const { siteSeeName, actionWord, siteSeeGuideMode } = useContext(SiteSeeContext);
  const setActiveZoom = useMapStateStore((state) => state.setActiveZoom);
  const mapConfig = useConfigStore((state) => state.mapConfig);
  const { googleMapsConfig } = mapConfig || {};
  const { enableLevels: mapZoomToEnableLevels } = googleMapsConfig?.zooms || {};

  const isCoached = siteSeeGuideMode === 'tour';
  const mapShell = document?.querySelector('.mapShell') ? document.querySelector('.mapShell') : null;
  const mapShellClassList = mapShell ? mapShell.classList : null;

  useEffect(() => {
    if (!mapShell) return;
    if (isCoached) {
      mapShellClassList.add('mapShell--dimForAmenities');
    } else {
      mapShellClassList.remove('mapShell--dimForAmenities');
    }
    return () => {
      mapShellClassList.remove('mapShell--dimForAmenities');
    };
  }, [isCoached, mapShell]);

  // This is the first step after zoom zones, so we need to click the zoom in.
  useEffect(() => {
    if (isCoached) {
      setActiveZoom(mapZoomToEnableLevels);
    }
  }, [isCoached]);

  return (
    <>
      { actionWord }
      {' '}
      any
      {' '}
      {siteSeeName}
      {' '}
      marker with an

      <span className="siteSeeGuide__amenityPlus pMarker__trigger">
        +
      </span>

      icon to reveal photos and more for a particular community amenity.
    </>
  );
};

export default SiteSeeAmenitiesGuide;
